// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SoramaPortalDb } from "libraries/IndexedDb/SoramaPortalDb";
import { Base64UriLocalStorageRepository } from "./Base64UriLocalStorageRepository";

@autoinject
export class LocalImageDataRepository extends Base64UriLocalStorageRepository {
    protected storeName: string = SoramaPortalDb.LocalImageDataStoreName;

    constructor(indexedDb: SoramaPortalDb) {
        super(indexedDb);
    }
}
